export enum SectionStatus {
  L1_APPROVED = "L1 Approved",
  L2_APPROVED = "L2 Approved",
  L1_REJECTED = "L1 Rejected",
  L2_REJECTED = "L2 Rejected",
  PENDING = "Pending",
  APPROVED = "Approved",
  REJECTED = "Rejected",
}
